var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCustomModels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.871,
    height: 130.828,
    viewBox: "0 0 144.871 130.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty_state_-_Virtual",
    "data-name": "Empty state - Virtual",
    transform: "translate(0 -16.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4055",
    "data-name": "Path 4055",
    d: "M134.679,58.756v58.336a6.366,6.366,0,0,1-6.349,6.384H17.269a6.366,6.366,0,0,1-6.349-6.384V46.275c0-3.2,2.158-5.79,4.815-5.79H56.422A4.913,4.913,0,0,1,60.9,44.132l2.728,8.24H128.33a6.366,6.366,0,0,1,6.349,6.384Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4056",
    "data-name": "Path 4056",
    d: "M86.712,31.536l13.6,65.171a2.573,2.573,0,0,1-1.994,3.045L40.08,111.9a2.573,2.573,0,0,1-3.045-1.994L20.789,32.059a2.573,2.573,0,0,1,1.994-3.045l45.561-9.508a3.55,3.55,0,0,1,1.017.451L85.885,30.779a3.452,3.452,0,0,1,.826.754Z",
    fill: "#ebeff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4057",
    "data-name": "Path 4057",
    d: "M48.436,34.064,31.794,37.538,35.267,54.18,51.91,50.706Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4058",
    "data-name": "Path 4058",
    d: "M75.9,28.334,59.254,31.808,62.728,48.45,79.37,44.976Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4059",
    "data-name": "Path 4059",
    d: "M61.079,42.634l-.871-4.175L62.73,40.11l-1.652,2.522Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4060",
    "data-name": "Path 4060",
    d: "M43.878,42.394,36.806,43.87a.637.637,0,1,0,.261,1.247l7.072-1.477a.637.637,0,0,0-.261-1.247Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4061",
    "data-name": "Path 4061",
    d: "M71.338,36.664l-7.072,1.477a.637.637,0,1,0,.261,1.247L71.6,37.911a.637.637,0,0,0-.261-1.247Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4062",
    "data-name": "Path 4062",
    d: "M41.4,45.083l-4.16.868A.637.637,0,1,0,37.5,47.2l4.16-.868a.637.637,0,1,0-.261-1.247Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4063",
    "data-name": "Path 4063",
    d: "M68.86,39.353l-4.16.868a.637.637,0,0,0,.261,1.247l4.16-.868a.637.637,0,0,0-.261-1.247Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4064",
    "data-name": "Path 4064",
    d: "M50.267,42.714,61.43,40.385",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4065",
    "data-name": "Path 4065",
    d: "M50.607,44.463a1.7,1.7,0,1,0-2.013-1.317A1.7,1.7,0,0,0,50.607,44.463Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4066",
    "data-name": "Path 4066",
    d: "M50.519,44.049a1.276,1.276,0,1,0-1.509-.989A1.276,1.276,0,0,0,50.519,44.049Z",
    fill: "#b0bfca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4067",
    "data-name": "Path 4067",
    d: "M53.429,57.169,36.787,60.643l3.474,16.642L56.9,73.811Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4068",
    "data-name": "Path 4068",
    d: "M80.889,51.439,64.247,54.913l3.474,16.642,16.642-3.474Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4069",
    "data-name": "Path 4069",
    d: "M66.071,65.741,65.2,61.565l2.522,1.651L66.07,65.738Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4070",
    "data-name": "Path 4070",
    d: "M48.871,65.5,41.8,66.976a.637.637,0,1,0,.261,1.247l7.072-1.477a.637.637,0,1,0-.261-1.247Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4071",
    "data-name": "Path 4071",
    d: "M76.332,59.769,69.26,61.246a.637.637,0,1,0,.261,1.247l7.072-1.477a.637.637,0,1,0-.261-1.247Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4072",
    "data-name": "Path 4072",
    d: "M46.393,68.188l-4.16.868a.637.637,0,1,0,.261,1.247l4.16-.868a.637.637,0,0,0-.261-1.247Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4073",
    "data-name": "Path 4073",
    d: "M73.854,62.458l-4.16.868a.637.637,0,0,0,.261,1.247l4.16-.868a.637.637,0,0,0-.261-1.247Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4074",
    "data-name": "Path 4074",
    d: "M55.26,65.82,66.423,63.49",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4075",
    "data-name": "Path 4075",
    d: "M55.6,67.569a1.7,1.7,0,1,0-2.013-1.317A1.7,1.7,0,0,0,55.6,67.569Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4076",
    "data-name": "Path 4076",
    d: "M55.512,67.154A1.276,1.276,0,1,0,54,66.166,1.276,1.276,0,0,0,55.512,67.154Z",
    fill: "#b0bfca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4077",
    "data-name": "Path 4077",
    d: "M86.8,31.656,76.125,33.883a4.817,4.817,0,0,1-5.7-3.733L68.2,19.471c.049.01.1.024.144.035a3.55,3.55,0,0,1,1.017.451L85.882,30.78a3.449,3.449,0,0,1,.826.754c.03.038.061.078.089.12Z",
    fill: "#d7dfe4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4078",
    "data-name": "Path 4078",
    d: "M121.214,46.27l-15.472,64.752a2.575,2.575,0,0,1-3.1,1.906L44.777,99.1A2.575,2.575,0,0,1,42.871,96l18.484-77.35a2.575,2.575,0,0,1,3.1-1.906l45.267,10.817a3.566,3.566,0,0,1,.728.843l10.335,16.833a3.531,3.531,0,0,1,.428,1.035Z",
    fill: "#f8f9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4079",
    "data-name": "Path 4079",
    d: "M85.512,32.245,68.977,28.293,65.025,44.828,81.56,48.78l3.952-16.535Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4080",
    "data-name": "Path 4080",
    d: "M112.795,38.763,96.26,34.811,92.308,51.346,108.843,55.3Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    "data-name": "Path 4081",
    d: "M93.3,45.388l.992-4.147,1.578,2.568L93.3,45.387Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4082",
    "data-name": "Path 4082",
    d: "M77.839,37.84l-7.026-1.68a.637.637,0,0,0-.3,1.238l7.026,1.68a.637.637,0,0,0,.3-1.238Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4083",
    "data-name": "Path 4083",
    d: "M105.121,44.358l-7.026-1.68a.637.637,0,0,0-.3,1.238l7.026,1.68a.637.637,0,1,0,.3-1.239Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4084",
    "data-name": "Path 4084",
    d: "M74.453,39.215l-4.133-.987a.637.637,0,1,0-.3,1.238l4.133.987a.637.637,0,1,0,.3-1.239Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    "data-name": "Path 4085",
    d: "M101.735,45.733,97.6,44.746a.637.637,0,1,0-.3,1.238l4.133.987a.637.637,0,1,0,.3-1.238Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4086",
    "data-name": "Path 4086",
    d: "M83.48,40.849,94.571,43.5",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4087",
    "data-name": "Path 4087",
    d: "M83.042,42.578a1.7,1.7,0,1,0-1.258-2.048A1.7,1.7,0,0,0,83.042,42.578Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4088",
    "data-name": "Path 4088",
    d: "M83.143,42.166a1.276,1.276,0,1,0-.945-1.537A1.277,1.277,0,0,0,83.143,42.166Z",
    fill: "#b0bfca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4089",
    "data-name": "Path 4089",
    d: "M80.183,55.274,63.648,51.322,59.7,67.857l16.535,3.952Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4090",
    "data-name": "Path 4090",
    d: "M107.465,61.792,90.931,57.84,86.979,74.375l16.534,3.952,3.952-16.535Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4091",
    "data-name": "Path 4091",
    d: "M87.966,68.418l.992-4.147,1.578,2.568-2.568,1.578Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4092",
    "data-name": "Path 4092",
    d: "M72.51,60.869l-7.026-1.68a.637.637,0,0,0-.3,1.238l7.027,1.68a.637.637,0,0,0,.3-1.238Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4093",
    "data-name": "Path 4093",
    d: "M99.792,67.387l-7.026-1.68a.637.637,0,1,0-.3,1.238l7.027,1.68a.637.637,0,1,0,.3-1.238Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4094",
    "data-name": "Path 4094",
    d: "M69.121,62.245l-4.133-.987a.637.637,0,1,0-.3,1.238l4.133.987a.637.637,0,0,0,.3-1.238Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4095",
    "data-name": "Path 4095",
    d: "M96.4,68.763l-4.133-.987a.637.637,0,0,0-.3,1.238L96.107,70a.637.637,0,0,0,.3-1.238Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4096",
    "data-name": "Path 4096",
    d: "M78.151,63.878l11.091,2.65",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4097",
    "data-name": "Path 4097",
    d: "M77.714,65.609a1.7,1.7,0,1,0-1.258-2.048A1.7,1.7,0,0,0,77.714,65.609Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4098",
    "data-name": "Path 4098",
    d: "M77.811,65.2a1.276,1.276,0,1,0-.945-1.537A1.277,1.277,0,0,0,77.811,65.2Z",
    fill: "#b0bfca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4099",
    "data-name": "Path 4099",
    d: "M121.244,46.417l-10.606-2.535a4.817,4.817,0,0,1-3.566-5.805l2.534-10.609c.041.031.079.062.117.092a3.568,3.568,0,0,1,.728.843l10.335,16.833a3.532,3.532,0,0,1,.428,1.035c.012.048.021.1.03.147Z",
    fill: "#ebeff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4100",
    "data-name": "Path 4100",
    d: "M144.871,72.56v67.549a7.412,7.412,0,0,1-7.431,7.391H7.431A7.412,7.412,0,0,1,0,140.109v-82c0-3.7,2.524-6.7,5.635-6.7H53.263A5.74,5.74,0,0,1,58.5,55.627l3.192,9.542H137.44A7.411,7.411,0,0,1,144.871,72.56Z",
    fill: "#e6ebf4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCustomModels);
export default __webpack_public_path__ + "static/media/empty-custom-models.3cf75651557e7daf26de44c616d11120.svg";
export { ForwardRef as ReactComponent };